/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { contractsUrl } from '@/constant';
import platform from '@/shared/utils/platform';
import { ContractTypeEnum } from '@/api/contract/types';
import type { Commodity, Contract } from '@/api/contract/types';
import { checkIfPdfLinkByExtension } from '@/shared/contract-controller';
import { withdrawingSpecialList } from '@/shared/contract-controller/config';
import ProductCommodity from '@/shared/commodity';

const style = require('./index.module.scss');
const defaultLogo:string = require('./image/logo.png');

@Component({ name: 'MultiChannelContracts' })
export default class MultiChannelContracts extends Vue {
  @Prop(Object) readonly channelList!: Commodity[];

  // 展开显示的渠道
  private ecpandChannel(channel: Commodity, event:Event) {
    if (channel.isExpand) return;
    event.preventDefault();
    event.stopPropagation();
    channel.isExpand = true;
  }

  // 切换协议
  private changeContractIndex(channel: Commodity, index: number,
    contract: Contract, event:Event) {
    event.preventDefault();
    event.stopPropagation();
    channel.contractActive = index;

    // 新增协议tab点击埋点
    this.$ubtPageButtonNew(
      'finance_agreementClick',
      {
        agreementName: contract.name,
        supplierCode: channel.productId,
        isopen: channel.isExpand,
      },
    );
  }

  /**
   * 是否展示pdf预览，历史渠道配置、pdf链接动态识别
   * @param commodityId 商品id
   * @param url 链接
   * @returns 是否展示pdf预览
   */
  private shouldPreviewPdfForWithdraw(commodityId: number | string, url: string) {
    // 8180渠道：只判断pdfLink
    // 非8180渠道：先判断specialList，再判断pdfLink
    if (String(commodityId) === ProductCommodity.AUTARKY_B_COMMODITY) {
      return checkIfPdfLinkByExtension(url);
    }
    return withdrawingSpecialList.includes(String(commodityId)) || checkIfPdfLinkByExtension(url);
  }

  // 获取Iframe url
  private getIframeUrl(channel: Commodity) {
    if (!channel.contractList || channel.contractList.length === 0) {
      return '';
    }
    const url = channel.contractList[channel.contractActive || 0].url || '';
    // pdf.js 底层目前最新的逻辑是不会解码的。后续遇到有渠道需要编码或者解码的时候，需要把这块逻辑前置加上，不放到 pdf.js 里面
    // const srcUrl = /%[0-9a-f]{2}/i.test(url) ? url : encodeURIComponent(url);
    // 由于提钱游渠道返回的协议链接是pdf，在安卓手机会存在直接跳转下载的问题
    // 且在ios设备上存在协议页面可横向滑动的问题
    // 因统一同意特地针对提钱游渠道 添加了pdf预览功能
    let src = '';

    if (this.shouldPreviewPdfForWithdraw(Number(channel.productId), url)) {
      src = `${contractsUrl || ''}?pdf_url=${url}`;
    } else {
      src = url;
    }
    return src;
  }

  private mounted() {
    if (this.channelList && this.channelList.length >= 1) {
      // 组件展示 协议曝光埋点数据
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const protocolExposeListData: any[] = [];
      this.channelList.map((item) => {
        protocolExposeListData.push({
          supplierCode: item.productId,
          agreementName: item.contractList[0].name,
        });
        return true;
      });
      this.$ubtModuleExposeNew(
        'finance_agreementClickFirst',
        {
          channelList: protocolExposeListData,
        },
      );
    }
  }

  private render() {
    return (
    <div
      ref='consentAgreement'
      class={[
        style.multiAgreement,
      ]}
    >
      <div class={style.agreementContent}>
      <div class={style.remark}>
                  以下资方将为您提供审核放款服务，若其中任何一家审批通过，则不再向其余机构提交申请。为提高您的申请审核效率，请在申请前务必阅读并同意以下第三方贷款机构的所有协议
                  </div>
      {this.channelList.map((channel) => (
      <div
        class={[
          style.channelInfo,
          platform.isHonor && style.smallMargin,
          this.channelList.length === 1 && style.singleChannel,
        ]}
        key={channel.productId}
      >
        {channel.productName && <div
          class={style.channelTitle}>
          <div class={style.channelName}>
            <div
              style={`background-image: url('${channel.productIcon || defaultLogo}')`}
              class={style.channelNameBg}
            />
            <div>{channel.productName}</div>
          </div>
        </div>}
        {channel.contractList.length > 1 && <div class={style.agreementBox}>
          <div class={style.agreementList}>
            {channel.contractList && channel.contractList.map((contract, contractIndex) => (
            <span
              class={channel.contractActive === contractIndex ? style.active : ''}
              onClick={this.changeContractIndex.bind(this, channel, contractIndex, contract)}
              key={contract.name}
            >
              《{contract.name.trim().replace(/^[<|《]?(.+?)[>|》]?$/, '$1')}》
            </span>
            ))}
          </div>
        </div>}
        {channel.contractType === ContractTypeEnum.creditInvestigationContract
          && <div class={style.remark}>
            为了完成审核，我们可能会委托专业机构对您进行必要查询，需要您阅读并同意以下协议
          </div>
        }
        <div
          class={[
            style.contractContent,
            channel.isExpand && style.expand,
          ]}
        >
          <iframe
            class={style.iframe}
            key={this.getIframeUrl(channel)}
            src={this.getIframeUrl(channel)}
          />
          {!channel.isExpand ? (
          <div>
            <div onClick={this.ecpandChannel.bind(this, channel)} class={style.shade} />
            <div class={style.expandContent}>
              <div class={style.expandText}>展开查阅</div>
            </div>
          </div>
          ) : null }
        </div>
      </div>))}
      </div>
    </div>);
  }
}
